import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import SecurityAccessDenied from "../../../../../../../../lib/go-security/components/AccessDenied";
import { hasPermission } from "../../../../../../../../services/organizations/selectors";
import RemoveOrganizationForm from "./components/RemoveOrganizationForm";

const RemoveOrganizationPage = () => {
	const { t } = useTranslation();
	const hasAccess = useSelector(hasPermission("DEFAULT"));
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.settings.field.remove_organization.title"));
	}, []);

	return (
		<div className="content">
			<Header title={t("modules.settings.field.remove_organization.title")} />
			{hasAccess ? <RemoveOrganizationForm /> : <SecurityAccessDenied />}
		</div>
	);
};

export default RemoveOrganizationPage;
